
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetoairporttonavimumbaicab() {



const cardData = {
  keyword: "Pune Airport to Navi Mumbai Cab",
  heading: "Skyline Cabs: Pune Airport to Navi Mumbai Cab",
  headingDescription: "Skyline Cabs provides reliable and professionally managed Pune Airport to Navi Mumbai Cab services for safe, punctual, and comfortable intercity airport transfers. Whether you are arriving at Pune Airport for business, corporate relocation, family visits, or returning home to Navi Mumbai, our well-maintained AC vehicles and experienced chauffeurs ensure a smooth highway journey. With flexible pickup coordination, real-time flight tracking, transparent fare calculation, and 24x7 availability, Skyline Cabs guarantees stress-free airport connectivity between Pune and Navi Mumbai.",

  top: "Top Places in Navi Mumbai to Visit After Airport Arrival",

  topPlaces: [
    {
      title: "Palm Beach Road",
      description: "Palm Beach Road is one of the most scenic and well-planned roads in Navi Mumbai, offering a smooth coastal drive experience. Travelers arriving via Pune Airport to Navi Mumbai Cab often enjoy this stretch for its wide lanes, sea views, and peaceful surroundings. The route connects major residential and commercial hubs like Vashi, Nerul, and Belapur. Evening drives along Palm Beach Road are especially popular due to stunning sunset views and less congestion. Skyline Cabs ensures comfortable drop service along this route after long airport travel."
    },
    {
      title: "Central Park Kharghar",
      description: "Central Park in Kharghar is one of the largest urban parks in the region and a popular relaxation spot for families and professionals. After booking Taxi Service Pune Airport to Navi Mumbai, many passengers plan a visit here for fresh air and peaceful surroundings. The park offers jogging tracks, amphitheaters, and landscaped gardens ideal for unwinding after travel."
    },
    {
      title: "Seawoods Grand Central Mall",
      description: "Seawoods Grand Central Mall is a premium shopping and entertainment destination. Passengers using Airport Taxi Pune to Navi Mumbai often stop here for dining or shopping after reaching the city."
    },
    {
      title: "Nerul Balaji Temple",
      description: "Nerul Balaji Temple offers a peaceful spiritual environment with beautiful hilltop views. Many families booking Pune Airport Pickup to Navi Mumbai include temple visits in their itinerary."
    },
    {
      title: "Belapur Fort",
      description: "Belapur Fort is a historical site offering panoramic views of Navi Mumbai. Travelers booking Pune Airport Transfer Cab Navi Mumbai often visit this heritage location."
    }
  ],

  services: [
    {
      name: "Pune Airport to Navi Mumbai Cab",
      description: "Skyline Cabs offers dependable Pune Airport to Navi Mumbai Cab service designed for comfortable intercity airport transfers. Our professional chauffeurs coordinate pickups based on flight schedules, ensuring punctual arrival even during late-night or early-morning flights. Vehicles are air-conditioned, clean, and maintained for long highway travel through expressways. Ideal for business professionals, families, and students, this service provides flexible scheduling, luggage-friendly vehicles, and transparent pricing."
    },
    {
      name: "Pune Airport to Navi Mumbai Taxi",
      description: "Pune Airport to Navi Mumbai Taxi service ensures smooth door-to-door transportation with experienced drivers and well-maintained vehicles. We prioritize safety, punctuality, and comfort during the intercity journey."
    },
    {
      name: "Cab from Pune Airport to Navi Mumbai",
      description: "Cab from Pune Airport to Navi Mumbai offers reliable long-distance connectivity with flexible departure timing and fixed fare clarity."
    },
    {
      name: "Taxi Service Pune Airport to Navi Mumbai",
      description: "Taxi Service Pune Airport to Navi Mumbai includes professional chauffeur assistance, airport coordination, and smooth highway driving."
    },
    {
      name: "Pune Airport Navi Mumbai Cab Service",
      description: "Pune Airport Navi Mumbai Cab Service provides clean vehicles, experienced drivers, and transparent fare structure for stress-free travel."
    },
    {
      name: "Pune Airport Pickup to Navi Mumbai",
      description: "Pune Airport Pickup to Navi Mumbai ensures timely airport arrival tracking and comfortable transfer planning."
    },
    {
      name: "Pune Airport Drop to Navi Mumbai",
      description: "Pune Airport Drop to Navi Mumbai offers scheduled departures ensuring passengers reach airport safely and on time."
    },
    {
      name: "Airport Taxi Pune to Navi Mumbai",
      description: "Airport Taxi Pune to Navi Mumbai guarantees smooth intercity travel with flexible booking and luggage support."
    },
    {
      name: "Pune Airport Transfer Cab Navi Mumbai",
      description: "Pune Airport Transfer Cab Navi Mumbai includes structured airport coordination and reliable long-distance connectivity."
    },
    {
      name: "Book Cab Pune Airport to Navi Mumbai",
      description: "Book Cab Pune Airport to Navi Mumbai easily through secure online booking system with instant confirmation."
    },
    {
      name: "Pune Airport to Navi Mumbai Cab Fare",
      description: "Pune Airport to Navi Mumbai Cab Fare is calculated transparently with clear breakdown including toll and driver allowance."
    },
    {
      name: "Pune Airport to Navi Mumbai Taxi Charges",
      description: "Pune Airport to Navi Mumbai Taxi Charges remain competitive and clearly structured without hidden fees."
    }
  ],

  tableData: [
    ["Pune Airport to Navi Mumbai Cab", "Pune Airport to Navi Mumbai Taxi"],
    ["Cab from Pune Airport to Navi Mumbai", "Taxi Service Pune Airport to Navi Mumbai"],
    ["Pune Airport Navi Mumbai Cab Service", "Pune Airport Pickup to Navi Mumbai"],
    ["Pune Airport Drop to Navi Mumbai", "Airport Taxi Pune to Navi Mumbai"],
    ["Pune Airport Transfer Cab Navi Mumbai", "Book Cab Pune Airport to Navi Mumbai"],
    ["Pune Airport to Navi Mumbai Cab Fare", "Pune Airport to Navi Mumbai Taxi Charges"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Reliable Airport Coordination",
      WhyChoosedescription: "We monitor flight schedules to ensure timely airport pickup and drop without delay."
    },
    {
      WhyChooseheading: "Comfortable Highway Travel",
      WhyChoosedescription: "Air-conditioned vehicles with smooth suspension ensure relaxed long-distance ride."
    },
    {
      WhyChooseheading: "Transparent Fare Structure",
      WhyChoosedescription: "Clear pricing breakdown with no hidden costs."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription: "Experienced drivers familiar with Pune–Navi Mumbai expressway routes."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription: "One-way, return, and scheduled airport transfer packages available."
    },
    {
      WhyChooseheading: "24x7 Availability",
      WhyChoosedescription: "Round-the-clock booking and support for early or late flights."
    },
    {
      WhyChooseheading: "Safe & Clean Vehicles",
      WhyChoosedescription: "Regularly sanitized and maintained cars ensure hygienic travel."
    },
    {
      WhyChooseheading: "Customer-Centric Service",
      WhyChoosedescription: "Dedicated support team ensures smooth airport transfer experience."
    }
  ]
}


const faqData = [
    {
        id: 1,
        question: 'How can I book a Pune Airport to Navi Mumbai Cab with Skyline Cabs?',
        answer:
            'Booking a Pune Airport to Navi Mumbai Cab with Skyline Cabs is quick and hassle-free. Simply visit our website or mobile app, select Pune Airport as your pickup location and Navi Mumbai as your drop destination, choose your preferred vehicle, and confirm instantly. You will receive immediate booking confirmation along with driver and vehicle details for complete transparency and smooth travel planning.',
    },
    {
        id: 2,
        question: 'Is Pune Airport to Navi Mumbai Cab service available 24/7?',
        answer:
            'Yes, Skyline Cabs offers 24/7 Pune Airport to Navi Mumbai Cab service. Whether your flight lands late at night or early in the morning, our professional drivers ensure punctual pickup directly from the airport. We monitor flight timings to provide timely service and avoid unnecessary waiting.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Pune Airport to Navi Mumbai Cab?',
        answer:
            'We provide multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Pune Airport to Navi Mumbai Cab bookings. You can select an economical sedan for budget travel or spacious SUVs for family and group trips. All vehicles are well-maintained, sanitized, and driven by experienced chauffeurs.',
    },
    {
        id: 4,
        question: 'How much is the Pune Airport to Navi Mumbai Cab fare?',
        answer:
            'The Pune Airport to Navi Mumbai Cab fare depends on the vehicle type and travel date. Skyline Cabs follows a transparent pricing policy, and the final fare is displayed before booking confirmation. The price includes driver allowance and applicable charges with no hidden costs.',
    },
    {
        id: 5,
        question: 'Is one-way Pune Airport to Navi Mumbai Cab available?',
        answer:
            'Yes, Skyline Cabs provides affordable one-way Pune Airport to Navi Mumbai Cab service. You only pay for the distance traveled without unnecessary return charges, making it cost-effective and convenient for single-direction travel.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Pune Airport to Navi Mumbai by cab?',
        answer:
            'The journey from Pune Airport to Navi Mumbai typically takes around 2.5 to 3.5 hours depending on traffic conditions. Our experienced drivers choose the best routes to ensure a smooth and comfortable highway travel experience.',
    },
    {
        id: 7,
        question: 'Is online payment available for Pune Airport to Navi Mumbai Cab booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payments via UPI, credit cards, debit cards, and net banking. Once payment is completed, you receive instant booking confirmation along with driver and trip details.',
    },
    {
        id: 8,
        question: 'Can I pre-book Pune Airport to Navi Mumbai Cab in advance?',
        answer:
            'Absolutely. You can pre-book your Pune Airport to Navi Mumbai Cab for any future date and time. Advance booking ensures guaranteed vehicle availability, especially during peak travel seasons and weekends.',
    },
    {
        id: 9,
        question: 'Is Pune Airport to Navi Mumbai Cab suitable for family travel?',
        answer:
            'Yes, our Pune Airport to Navi Mumbai Cab service is ideal for family and group travel. Spacious vehicles, comfortable seating, powerful AC, and ample luggage space ensure a relaxed and stress-free journey.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Pune Airport to Navi Mumbai Cab?',
        answer:
            'Skyline Cabs is trusted for Pune Airport to Navi Mumbai Cab service because of our professional chauffeurs, clean vehicles, transparent pricing, punctual airport pickups, and 24x7 customer support. We ensure safe, reliable, and comfortable long-distance travel every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Rahul Patil",
        rating: 5,
        review: "Booked Pune Airport to Navi Mumbai Cab with Skyline Cabs after my evening flight. The driver was waiting on time, the car was clean, and the ride was smooth. Excellent long-distance service!"
    },
    {
        name: "Mrs. Snehal Desai",
        rating: 4,
        review: "Very reliable Pune Airport to Navi Mumbai Cab service. Transparent pricing and comfortable vehicle made our journey stress-free. Skyline Cabs provides professional airport transfer service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport to Navi Mumbai Cab",
  "image": "https://skylinecabs.com/assets/images/pune-airport-to-navi-mumbai-cab.jpg",
  "description": "Book Pune Airport to Navi Mumbai Cab with Skyline Cabs for safe, comfortable, and reliable airport transfers. Professional drivers available for pickup and drop services with affordable fares and well-maintained vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-airport-to-navi-mumbai-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Pune Airport to Navi Mumbai Cab | Airport Pickup & Drop | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Airport to Navi Mumbai Cab with Skyline Cabs for safe and reliable airport transfers. Affordable fares with professional drivers for pickup and drop services." 
  />
  <meta 
    name="keywords" 
    content="Pune Airport to Navi Mumbai Cab, Pune Airport to Navi Mumbai Taxi, Cab from Pune Airport to Navi Mumbai, Taxi Service Pune Airport to Navi Mumbai, Pune Airport Navi Mumbai Cab Service, Pune Airport Pickup to Navi Mumbai, Pune Airport Drop to Navi Mumbai, Airport Taxi Pune to Navi Mumbai, Pune Airport Transfer Cab Navi Mumbai, Book Cab Pune Airport to Navi Mumbai, Pune Airport to Navi Mumbai Cab Fare, Pune Airport to Navi Mumbai Taxi Charges, Skyline Cabs Pune Airport to Navi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/135.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoairporttonavimumbaicab;